import { UserPlus, ArrowRightLeft, Users } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const REG_TYPES = [
  { key: "new", label: "New player", hint: "Joining the club — kit and payment proof as usual", Icon: UserPlus },
  { key: "transfer", label: "Transfer", hint: "Moving from one of our teams to another", Icon: ArrowRightLeft },
  { key: "dual", label: "Dual registration", hint: "Also playing for a second team in the club", Icon: Users },
];

export function RegTypePicker({ value, onChange, disabled }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="reg-type-picker">
      {REG_TYPES.map(({ key, label, hint, Icon }) => (
        <button key={key} type="button" disabled={disabled} onClick={() => onChange(key)} data-testid={`reg-type-${key}`}
          className={`text-left rounded-md border p-3 transition-colors disabled:opacity-50 ${value === key ? "border-[#83B68B] bg-[#83B68B]/10" : "border-border hover:border-[#83B68B]/50"}`}>
          <div className={`text-xs tracking-widest uppercase font-display font-bold inline-flex items-center gap-1.5 ${value === key ? "text-[#83B68B]" : ""}`}><Icon className="w-3.5 h-3.5" /> {label}</div>
          <div className="text-[11px] opacity-60 mt-1 leading-snug">{hint}</div>
        </button>
      ))}
    </div>
  );
}

export function TeamSelect({ label, value, onChange, teams, testId, exclude, required = true }) {
  return (
    <div>
      <Label className="text-[10px] tracking-widest uppercase opacity-70">{label}{required && <span className="text-[#83B68B]"> *</span>}</Label>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder="Pick a team" /></SelectTrigger>
        <SelectContent>{(teams || []).filter(t => t.id !== exclude).map(t => <SelectItem key={t.id} value={t.id}>{t.age_group} · {t.name}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}
